<script setup lang="ts">
  import { provide } from 'vue'
  import { type FieldContextVariant, FIELD_CONTEXT_KEY } from './field-context'

  const props = withDefaults(
    defineProps<{
      variant?: FieldContextVariant
    }>(),
    { variant: 'stacked' }
  )

  provide(FIELD_CONTEXT_KEY, { variant: props.variant })
</script>

<template>
  <slot />
</template>
